import { useGetManagedEmployerQuery } from "../get-managed-employer";

export const useIsEmployerApproved = (): boolean | undefined => {
  const { data } = useGetManagedEmployerQuery();

  return data ? Boolean(data?.approved) : undefined;
};
